export enum StatusCommande {  
  bcd = 1,
  paye = 2,
  preparation = 3,
  envoye = 4,  
  livre = 5,  
  annule = 6,
  rembourse = 7,
  enLivraison = 8,
  enAttentePaiement = 9,
  devis = 10,
  enCoursAppro = 11,
  erreur = 12
}
